import React from "react";
import Container from "react-bootstrap/Container";
import { SideBar } from "./sideBar";
import { NavBar } from "./navBar";
import { ListClients } from "./clients/listClients";
import { Row, Card} from 'react-bootstrap';
import useStoredPermissions from './useStoredPermissions';
import { useTranslation } from 'react-i18next';

export const MainDashboard = ()=> {

    const { t } = useTranslation();
    const permissions = useStoredPermissions() || [];

    const hasPermissions = permissions.includes("Super User") || permissions.includes("Read Video") || permissions.includes("Read Routine");

    return(
        <React.Fragment>
            {hasPermissions && <SideBar />}
            <Container>
                <NavBar/>
                <Container>
                    <Row>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">{t('dashboard.listClientsTitle')}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <ListClients/>
                            </Card.Body>
                        </Card>
                    </Row>
                </Container>
            </Container>
        </React.Fragment>
    );
}